<section
  class="mb-6 rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white p-5">

  <div class="grid grid-cols-12 gap-4">

    <div class="col-span-12 lg:col-span-7">
      <p
        class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Central Meta Connection
      </p>

      <h3 class="mt-1 text-xl font-bold text-gray-900">
        Connect Facebook and Instagram
      </h3>

      <p class="mt-2 text-sm leading-6 text-gray-600">
        Connect a Facebook Page and its linked Instagram
        Professional account without copying access tokens.
      </p>
    </div>

    <div class="col-span-12 lg:col-span-5">
      <label
        for="publio-meta-site"
        class="mb-2 block text-sm font-semibold text-gray-700">
        Publio Site
      </label>

      <select
        id="publio-meta-site"
        [ngModel]="selectedSiteId"
        (ngModelChange)="onSiteChange($event)"
        [disabled]="
          loadingConnect ||
          loadingAssets ||
          loadingStatus ||
          confirming
        "
        class="h-12 w-full rounded-xl border border-gray-300 bg-white px-3 text-sm text-gray-800 outline-none focus:border-gray-500 focus:ring-2 focus:ring-gray-200">

        <option [ngValue]="null">
          Select a Site
        </option>

        <option
          *ngFor="let site of sites"
          [ngValue]="site.id">
          {{ site.domain }}
        </option>
      </select>

      <button
        type="button"
        (click)="connect()"
        [disabled]="
          !selectedSiteId ||
          loadingConnect ||
          loadingAssets ||
          confirming
        "
        class="primary-btn mt-3 h-12 w-full rounded-xl px-5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50">

        {{
          loadingConnect
            ? "Opening Meta..."
            : "Connect with Meta"
        }}
      </button>
    </div>

    <div
      *ngIf="loadingStatus"
      class="col-span-12 rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-700">
      Loading Meta connection status...
    </div>

    <div
      *ngIf="connectionStatus && !loadingStatus"
      class="col-span-12 rounded-xl border border-gray-300 bg-white p-4">

      <div class="grid grid-cols-12 gap-4">

        <div class="col-span-12 md:col-span-3">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Status
          </p>

          <p
            class="mt-1 text-sm font-bold"
            [class.text-green-700]="connectionStatus.connected"
            [class.text-gray-700]="!connectionStatus.connected">
            {{
              connectionStatus.connected
                ? "Connected"
                : "Not connected"
            }}
          </p>
        </div>

        <div class="col-span-12 md:col-span-3">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Facebook Page
          </p>

          <p class="mt-1 text-sm font-medium text-gray-800">
            {{
              connectionStatus.facebook_page_name ||
              "Not selected"
            }}
          </p>
        </div>

        <div class="col-span-12 md:col-span-3">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Instagram
          </p>

          <p class="mt-1 text-sm font-medium text-gray-800">
            {{
              connectionStatus.instagram_username
                ? "@" + connectionStatus.instagram_username
                : "Not selected"
            }}
          </p>
        </div>

        <div class="col-span-12 md:col-span-3">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-500">
            Last validation
          </p>

          <p class="mt-1 text-sm font-medium text-gray-800">
            {{
              connectionStatus.last_validated_at
                ? (
                    connectionStatus.last_validated_at
                    | date: "medium"
                  )
                : "Not validated"
            }}
          </p>
        </div>

      </div>
    </div>

    <div
      *ngIf="loadingAssets"
      class="col-span-12 rounded-xl border border-gray-300 bg-gray-50 px-4 py-3 text-sm text-gray-700">
      Loading available Facebook and Instagram accounts...
    </div>

    <div
      *ngIf="errorMessage"
      class="col-span-12 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
      {{ errorMessage }}
    </div>

    <div
      *ngIf="connected"
      class="col-span-12 rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
      Meta connection saved successfully.
    </div>

    <div
      *ngIf="pages.length"
      class="col-span-12">

      <h4 class="mb-3 text-sm font-bold text-gray-900">
        Select Facebook Page and Instagram account
      </h4>

      <div class="grid grid-cols-12 gap-3">

        <label
          *ngFor="
            let page of pages;
            trackBy: trackByPageId
          "
          class="col-span-12 cursor-pointer rounded-xl border p-4 transition md:col-span-6"
          [class.border-gray-700]="selectedPageId === page.id"
          [class.bg-gray-50]="selectedPageId === page.id"
          [class.border-gray-200]="selectedPageId !== page.id">

          <div class="flex items-start gap-3">
            <input
              type="radio"
              name="publio-meta-page"
              [value]="page.id"
              [(ngModel)]="selectedPageId"
              class="mt-1 h-4 w-4">

            <div class="min-w-0">
              <p class="font-semibold text-gray-900">
                {{ page.name || "Facebook Page" }}
              </p>

              <p class="mt-1 text-sm text-gray-600">
                Instagram:
                <span class="font-medium">
                  {{
                    page.instagram_username
                      ? "@" + page.instagram_username
                      : page.instagram_business_account_id
                  }}
                </span>
              </p>

              <p class="mt-2 text-xs text-gray-500">
                {{ page.tasks.join(", ") || "No tasks returned" }}
              </p>
            </div>
          </div>
        </label>

      </div>

      <button
        type="button"
        (click)="confirm()"
        [disabled]="!selectedPageId || confirming"
        class="primary-btn mt-4 h-12 rounded-xl px-6 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50">

        {{
          confirming
            ? "Saving connection..."
            : "Confirm Meta Connection"
        }}
      </button>
    </div>

  </div>
</section>
